import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
var CommissionCompetences = {
  BankSlip: { Show: false },
  CreditCard: { Show: false },
  Crypto: { Show: false },
  DebitCard: { Show: false }
};
const request = {
  install(Vue) {
    Vue.prototype.$requestGetCommissionCompetence = function (partnerType) {
      return new Promise(function(resolve) {
          this.$store.dispatch("ListCalculatorCommissionCompetence",
          { "Object.PartnerType.Code": partnerType }
        ).then(
          res => {
            for (let x = 0; x < res.length; x++) {
              switch (
              res[x].PaymentMethod.Code // Bankslip
              ) {
                case "1":
                  CommissionCompetences.BankSlip.Show = true;
                  CommissionCompetences.BankSlip.Name =
                    res[x].PaymentMethod.Name;
                  CommissionCompetences.BankSlip.Taxes =
                    res[x].CommissionCompetence;
                  CommissionCompetences.BankSlip.Labels = [];

                  for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
                    CommissionCompetences.BankSlip.Labels.push(
                      this.$floatToReal(
                        res[x].CommissionCompetence[y].Tax,
                        res[x].CommissionCompetence[y].TaxType.Id
                      )
                    );
                  }
                  break;
                case "2":
                  CommissionCompetences.CreditCard.Show = true;
                  CommissionCompetences.CreditCard.Name =
                    res[x].PaymentMethod.Name;
                  CommissionCompetences.CreditCard.Taxes =
                    res[x].CommissionCompetence;

                  CommissionCompetences.CreditCard.Labels = [];

                  for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
                    CommissionCompetences.CreditCard.Labels.push(
                      this.$floatToReal(
                        res[x].CommissionCompetence[y].Tax,
                        res[x].CommissionCompetence[y].TaxType.Id
                      )
                    );
                  }
                  break;
                case "3":
                  CommissionCompetences.Crypto.Show = true;
                  CommissionCompetences.Crypto.Name =
                    res[x].PaymentMethod.Name;
                  CommissionCompetences.Crypto.Taxes =
                    res[x].CommissionCompetence;

                  CommissionCompetences.Crypto.Labels = [];

                  for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
                    CommissionCompetences.Crypto.Labels.push(
                      this.$floatToReal(
                        res[x].CommissionCompetence[y].Tax,
                        res[x].CommissionCompetence[y].TaxType.Id
                      )
                    );
                  }
                  break;
                case "4":
                  CommissionCompetences.DebitCard.Show = true;
                  CommissionCompetences.DebitCard.Name =
                    res[x].PaymentMethod.Name;
                  CommissionCompetences.DebitCard.Taxes =
                    res[x].CommissionCompetence;

                  CommissionCompetences.DebitCard.Labels = [];

                  for (let y = 0; y < res[x].CommissionCompetence.length; y++) {
                    CommissionCompetences.DebitCard.Labels.push(
                      this.$floatToReal(
                        res[x].CommissionCompetence[y].Tax,
                        res[x].CommissionCompetence[y].TaxType.Id
                      )
                    );
                  }
                  break;
              }
            }
            this.$store.commit(
              "SET_COMMISSION_COMPETENCE_LIST",
              CommissionCompetences
            );
            resolve(true);
          },
          error => {
            console.error("Erro ao carregar CommissionCompetences...");
            resolve(false);
          }
        );
      }.bind(this));
    },
      Vue.prototype.$floatToReal = function (v, t) {
        if (t === 2) {
          return "R$ " + v.toFixed(2).replace(".", ",");
        } else {
          return v.toFixed(2) + "%";
        }
      };
  }
};

export default request;



// WEBPACK FOOTER //
// ./src/utils/requestGetCommissionCompetence.js